export const POST_TYPES = {
    image: 0,
    video: 1,
    audio: 2,
};

